module.exports = __webpack_public_path__ + "static/media/thumbnail.dd3635b0.jpg";